import { Model } from '@nozbe/watermelondb'
import { field, date, readonly, relation, children } from '@nozbe/watermelondb/decorators'

export class Customer extends Model {
    static table = 'customers'
    static associations = {
        stores: { type: 'belongs_to', key: 'store_id' },
        invoices: { type: 'has_many', foreignKey: 'customer_id' },
        loyalty_transactions: { type: 'has_many', foreignKey: 'customer_id' },
    } as const

    @field('store_id') storeId!: string
    @field('name') name!: string | null
    @field('phone') phone!: string | null
    @field('email') email!: string | null
    @field('gstin') gstin!: string | null
    @field('pan') pan!: string | null
    @field('address') address!: string | null
    @field('city') city!: string | null
    @field('state') state!: string | null
    @field('pincode') pincode!: string | null
    @field('group_id') groupId!: string | null
    @field('credit_limit') creditLimit!: number
    @field('balance') balance!: number
    @field('loyalty_tier_id') loyaltyTierId!: string | null
    @field('loyalty_points') loyaltyPoints!: number
    @field('total_spend') totalSpend!: number
    @field('visit_count') visitCount!: number
    @date('last_visit_at') lastVisitAt!: Date | null
    @date('birthday') birthday!: Date | null
    @date('anniversary') anniversary!: Date | null
    @field('tags') tags!: string | null
    @field('version') version!: number
    @field('is_synced') isSynced!: boolean
    @field('is_deleted') isDeleted!: boolean
    @field('last_sync_balance') lastSyncBalance!: number | null
    @field('last_sync_total_spend') lastSyncTotalSpend!: number | null
    @field('last_sync_loyalty_points') lastSyncLoyaltyPoints!: number | null
    @field('last_sync_visit_count') lastSyncVisitCount!: number | null
    @readonly @date('created_at') createdAt!: Date
    @readonly @date('updated_at') updatedAt!: Date

    @relation('stores', 'store_id') store: any
    @children('invoices') invoices: any
    @children('loyalty_transactions') loyaltyTxns: any
}

export class CustomerGroup extends Model {
    static table = 'customer_groups'
    @field('merchant_id') merchantId!: string
    @field('name') name!: string
    @field('price_list_id') priceListId!: string | null
    @field('discount_percent') discountPercent!: number
    @field('version') version!: number
    @field('is_synced') isSynced!: boolean
    @field('is_deleted') isDeleted!: boolean
    @readonly @date('created_at') createdAt!: Date
    @readonly @date('updated_at') updatedAt!: Date
}

export class LoyaltyTier extends Model {
    static table = 'loyalty_tiers'
    @field('merchant_id') merchantId!: string
    @field('name') name!: string
    @field('min_spend') minSpend!: number
    @field('points_multiplier') pointsMultiplier!: number
    @field('discount_percent') discountPercent!: number
    @field('sort_order') sortOrder!: number
    @field('version') version!: number
    @field('is_synced') isSynced!: boolean
    @field('is_deleted') isDeleted!: boolean
    @readonly @date('created_at') createdAt!: Date
    @readonly @date('updated_at') updatedAt!: Date
}

export class LoyaltyTransaction extends Model {
    static table = 'loyalty_transactions'
    @field('customer_id') customerId!: string
    @field('type') type!: string
    @field('points') points!: number
    @field('reference_id') referenceId!: string | null
    @field('notes') notes!: string | null
    @field('version') version!: number
    @field('is_synced') isSynced!: boolean
    @field('is_deleted') isDeleted!: boolean
    @readonly @date('created_at') createdAt!: Date
    @readonly @date('updated_at') updatedAt!: Date
}
